<template>
	<div class="doc-wrapper">
    <!-- <img :src="attachmentUrl" /> -->
    <iframe class="allScreen" frameborder="0" :src="attachmentUrl"></iframe>
  </div>
</template>
<script>
export default {
	name: "downloadDoc",
	data() {
		return {
			attachmentUrl: ''
		};
	},
	mounted() {
    this.attachmentUrl = decodeURIComponent(location.search.split("=")[1]);
    // location.href=this.attachmentUrl;
	}
};
</script>
<style lang="scss" scoped>
  .doc-wrapper {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }
  .allScreen {
    width: 90%;
    height: 90%;
    overflow: hidden;
  }
</style>